export default "/images/cover2.jpg?ee1d8df1cbde192458b19eda4311f7b3";